import api from "../../Http/global-vars";
import { DASHBOARD } from "../types";
import axios from "axios";

export const fetchDashboard = () => {
  return async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
      },
    };
    const url = api + "dashboardadmin/";
    await axios
      .get(url, config)
      .then(async (res) => {
        // const data = await res.json();
        // console.log("data dashboard", res);
        dispatch({
          type: DASHBOARD,
          payload: res?.data?.data,
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
